import { useEffect, useState } from 'react';

/**
 * Linear 风格顶部阅读进度：1px 冷白光学轨道，随页面滚动充能。
 * 仅作为氛围细节，不参与交互。
 */
export function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      setProgress(scrollable > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollable)) : 0);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  if (progress <= 0.002) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-40 h-px" aria-hidden="true">
      <div
        className="h-full bg-gradient-to-r from-white/25 via-white/70 to-[#BAE6FD]/80 shadow-[0_0_10px_rgba(255,255,255,0.5)] transition-[width] duration-150"
        style={{ width: `${progress * 100}%` }}
      />
    </div>
  );
}

/**
 * 全站光标折射：为任意 `.spotlight-card` 写入 --mouse-x / --mouse-y，
 * 驱动 CSS 的 75% 透镜跟随高光（参考 React Bits Spotlight Card 的交互，但用纯 CSS 实现）。
 */
export function PointerLighting() {
  useEffect(() => {
    let current: HTMLElement | null = null;
    const clear = () => {
      if (current) {
        current.style.removeProperty('--mouse-x');
        current.style.removeProperty('--mouse-y');
        current = null;
      }
    };
    const onMove = (event: PointerEvent) => {
      const target = (event.target as Element | null)?.closest?.('.spotlight-card');
      if (!(target instanceof HTMLElement)) {
        clear();
        return;
      }
      if (current && current !== target) clear();
      const rect = target.getBoundingClientRect();
      target.style.setProperty('--mouse-x', `${event.clientX - rect.left}px`);
      target.style.setProperty('--mouse-y', `${event.clientY - rect.top}px`);
      current = target;
    };
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerleave', clear);
    return () => {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerleave', clear);
    };
  }, []);
  return null;
}
